<template>
  <custom-dialog
    :is-dialog-open="isDialogOpen"
    :dialog-title="dialogTitle"
    max-width="800px"
    :close-dialog="closeDialog"
  >
    <v-form
      class="multi-col-validation"
      @submit.prevent="handleSubmitBtnClick"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="comentarioLocale.pessoaNome"
            dense
            outlined
            validate-on-blur
            label="Pessoa nome"
            :rules="[v => !!v || 'Campo obrigatório', v => !v || v.length <= 50 || 'Máximo de 50 caracteres']"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="comentarioLocale.comentario"
            dense
            outlined
            no-resize
            clearable
            validate-on-blur
            label="Comentário"
            counter="500"
            :rules="[v => !!v || 'Campo obrigatório', v => !v || v.length <= 500 || 'Máximo de 500 caracteres']"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            outlined
            color="secondary"
            class="mr-4"
            @click="resetFormAndCloseDialog"
          >
            Cancelar
          </v-btn>

          <v-btn
            type="submit"
            color="primary"
          >
            <v-progress-circular
              v-if="isSaveComentarioLoading"
              indeterminate
              color="secundary"
            />

            <span v-else>Salvar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </custom-dialog>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import CustomDialog from '@/components/dialog/Dialog.vue'
import useDialog from '@/composables/useDialog'
import TicketService from '@/services/modules/TicketService'

export default {
  components: {
    CustomDialog,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    ticketAgendamentoId: {
      type: Number,
      required: true,
    },
    comentarioSelecionado: {
      type: Object,
      default: null,
    },
  },

  setup(props, { emit }) {
    const { loading: isSaveComentarioLoading, emitRefetchData, resetForm, closeDialog } = useDialog(emit, 'is-dialog-open')

    const comentarioLocale = ref({
      pessoaNome: '',
      comentario: '',
    })

    const isComentarioNovo = computed(() => !props.comentarioSelecionado)
    const dialogTitle = computed(() => (isComentarioNovo.value ? 'Criar comentário' : 'Editar comentário'))

    function resetFormAndCloseDialog() {
      resetForm()
      closeDialog()
    }

    watch(
      () => props.comentarioSelecionado,
      v => {
        if (!v) {
          comentarioLocale.value.pessoaNome = ''
          comentarioLocale.value.comentario = ''

          return
        }

        comentarioLocale.value.pessoaNome = v.pessoaNome
        comentarioLocale.value.comentario = v.comentario
      },
      { immediate: true, deep: true },
    )

    async function handleSubmitBtnClick() {
      if (isSaveComentarioLoading.value) return

      try {
        isSaveComentarioLoading.value = true

        if (isComentarioNovo.value) {
          await TicketService.criarAgendamentoComentario(props.ticketAgendamentoId, comentarioLocale.value)
        } else {
          await TicketService.atualizarAgendamentoComentario(props.ticketAgendamentoId, props.comentarioSelecionado.id, comentarioLocale.value)
        }

        emitRefetchData()
        resetFormAndCloseDialog()
      } finally {
        isSaveComentarioLoading.value = false
      }
    }

    return {
      isSaveComentarioLoading,
      comentarioLocale,
      dialogTitle,
      closeDialog,
      resetFormAndCloseDialog,
      handleSubmitBtnClick,
    }
  },
}
</script>
